<template>
  <div>
    <el-table :data="list" style="width:100%" size="small" border v-loading="loading">
      <el-table-column prop="order_sn" label="订单编号" width="220"></el-table-column>
      <el-table-column prop="title" label="订单类型"></el-table-column>
      <el-table-column prop="total_money" label="金额（元）" width="120" align="center">
        <template slot-scope="scope"><span style="color:#f56c6c;">¥{{ scope.row.total_money }}</span></template>
      </el-table-column>
      <el-table-column prop="create_time" label="下单时间" width="170"></el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.status === 'paid' ? 'success' : 'warning'">
            {{ scope.row.status === 'paid' ? '已支付' : '未支付' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onOrderDetail(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap" v-if="total > 10">
      <el-pagination background :page-size="10" layout="prev, pager, next"
        :total="total" :current-page.sync="page" @current-change="getOrderList"></el-pagination>
    </div>
    <div v-if="list.length === 0 && !loading" class="empty-tip">暂无订单</div>

    <el-dialog title="订单详情" :visible.sync="detailVisible" width="600px" center>
      <el-table :data="detailItems" size="small" border style="width:100%">
        <el-table-column prop="goods_name" label="书籍名称"></el-table-column>
        <el-table-column prop="goods_price" label="价格" width="100" align="center"></el-table-column>
      </el-table>
      <div class="detail-ship">
        <p>收货人：{{ detail.ship_username }}</p>
        <p>联系电话：{{ detail.ship_mobile }}</p>
        <p>收货地址：{{ detail.ship_address }}</p>
      </div>
      <span slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { orderDetails, orderList } from "@/api";
export default {
  data() {
    return { loading: false, list: [], total: 0, page: 1, detail: {}, detailVisible: false };
  },
  computed: {
    detailItems() {
      const item = this.detail.orderitem;
      if (!item) return [];
      return Array.isArray(item) ? item : [item];
    },
  },
  methods: {
    getOrderList() {
      this.loading = true;
      orderList({ page: this.page }).then((res) => {
        this.loading = false;
        if (res.data.code === 1) {
          this.list = res.data.data.data || [];
          this.total = res.data.data.total || 0;
        }
      }).catch(() => { this.loading = false; });
    },
    onOrderDetail(row) {
      this.detailVisible = true;
      orderDetails({ id: row.id }).then((res) => {
        if (res.data.code === 1) this.detail = res.data.data;
      });
    },
  },
  mounted() { this.getOrderList(); },
};
</script>

<style scoped>
.pagination-wrap { text-align: center; margin-top: 16px; }
.empty-tip { text-align: center; color: #999; padding: 40px 0; font-size: 14px; }
.detail-ship { padding: 16px 0 0; line-height: 2; font-size: 14px; color: #606266; }
</style>
